/*
  Product finder quiz.

  Scoring is deliberately plain: each answer names the product handles it votes
  for, votes accumulate across answers, and the highest scorers win. Products
  with no votes are excluded, so an unanswered quiz recommends nothing rather
  than defaulting to whatever is first in the catalogue.

  The recommendation is assembled from product cards already rendered
  server-side, so the quiz can never show a product, price or image that isn't
  real.
*/
(function () {
  'use strict';
  var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function parseVotes(value) {
    return String(value || '')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  }

  /** Tally answer values into a handle -> score map. A handle written as
      "-handle" excludes that product entirely (e.g. "avoid caffeine"). */
  function tally(answers) {
    var scores = {};
    var excluded = {};
    answers.forEach(function (value) {
      parseVotes(value).forEach(function (handle) {
        if (handle.charAt(0) === '-') { excluded[handle.slice(1)] = true; return; }
        scores[handle] = (scores[handle] || 0) + 1;
      });
    });
    Object.keys(excluded).forEach(function (handle) { delete scores[handle]; });
    return scores;
  }

  /** Rank handles by score; ties break toward catalogue order. */
  function rank(handles, scores, limit) {
    return handles
      .map(function (handle, index) {
        return {handle: handle, index: index, score: scores[handle.toLowerCase()] || 0};
      })
      .filter(function (e) { return e.score > 0; })
      .sort(function (a, b) { return b.score - a.score || a.index - b.index; })
      // Extra picks only when they are a real match: more than half the top score.
      .filter(function (e, i, list) { return i === 0 || e.score > list[0].score / 2; })
      .slice(0, limit)
      .map(function (e) { return e.handle; });
  }

  var moneyFormat = (window.Nutritia && window.Nutritia.moneyFormat) || '${{amount}}';
  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  document.querySelectorAll('[data-quiz]').forEach(function (root) {
    var intro = root.querySelector('[data-quiz-intro]');
    var run = root.querySelector('[data-quiz-run]');
    var result = root.querySelector('[data-quiz-result]');
    var startBtn = root.querySelector('[data-quiz-start]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var bundle = root.querySelector('[data-quiz-bundle]');
    var catalogue = root.querySelector('[data-quiz-catalogue]');
    var progress = root.querySelector('[data-quiz-progress]');
    var countEl = root.querySelector('[data-quiz-count]');
    var limit = Number(root.getAttribute('data-limit') || 2);
    var cta = root.querySelector('[data-quiz-cta]');
    var addBtn = root.querySelector('[data-quiz-add]');

    if (!steps.length || !startBtn) return;

    // Only reveal the start button once the script is running, so a no-JS
    // visitor sees the fallback link instead of a dead button.
    startBtn.hidden = false;

    var answers = [];
    var current = 0;
    // "Open" mode shows question 1 straight away, so the first thing a visitor
    // can do on the homepage is tap their goal — no start button in between.
    var openMode = root.getAttribute('data-open') === 'true';

    function showPane(pane) {
      [intro, run, result].forEach(function (p) { if (p) p.hidden = p !== pane; });
    }

    function renderStep(index, quiet) {
      steps.forEach(function (s, i) { s.hidden = i !== index; });
      var pct = (index / steps.length) * 100;
      if (progress) progress.style.width = pct + '%';
      if (countEl) countEl.textContent = window.Nutritia.t('quiz_question', 'Question {n} of {total}', {n: index + 1, total: steps.length});

      var back = steps[index].querySelector('[data-quiz-back]');
      if (back) back.hidden = index === 0;

      // Move focus for keyboard and screen-reader users as they answer — but
      // never on page load, where it would yank the page down to the quiz.
      var legend = steps[index].querySelector('.quiz__question');
      if (legend && !quiet) legend.focus({preventScroll: true});
    }

    function finish() {
      var scores = tally(answers);
      var handles = Array.prototype.slice
        .call(catalogue.querySelectorAll('[data-quiz-product]'))
        .map(function (el) { return el.getAttribute('data-quiz-product'); });
      var winners = rank(handles, scores, limit);

      bundle.innerHTML = '';
      if (!winners.length) {
        var p = document.createElement('p');
        p.className = 'quiz__note';
        p.textContent = window.Nutritia.t('quiz_no_match', 'No clear match — browse the full range instead.');
        bundle.appendChild(p);
      } else {
        winners.forEach(function (handle) {
          var src = catalogue.querySelector('[data-quiz-product="' + handle + '"]');
          if (src) bundle.appendChild(src.firstElementChild.cloneNode(true));
        });
      }

      // One button adds every recommended product that can be bought.
      var buyable = winners
        .map(function (h) { return catalogue.querySelector('[data-quiz-product="' + h + '"]'); })
        .filter(function (el) { return el && el.getAttribute('data-available') === 'true'; });
      if (cta && addBtn) {
        cta.hidden = !buyable.length;
        if (buyable.length) {
          var total = buyable.reduce(function (sum, el) { return sum + Number(el.getAttribute('data-price')); }, 0);
          addBtn.setAttribute('data-bundle-add', buyable.map(function (el) { return el.getAttribute('data-variant'); }).join(','));
          var label = buyable.length === 1 ? window.Nutritia.t('add_to_cart', 'Add to cart') : buyable.length === 2 ? window.Nutritia.t('quiz_add_two', 'Add both to cart') : window.Nutritia.t('quiz_add_all', 'Add all {n} to cart', {n: buyable.length});
          addBtn.textContent = label + ' \u00b7 ' + money(total);
        }
      }

      if (progress) progress.style.width = '100%';
      showPane(result);
      result.scrollIntoView({behavior: scrollBehavior, block: 'center'});
      var resultHeading = result.querySelector('.quiz__title');
      if (resultHeading) { resultHeading.setAttribute('tabindex', '-1'); resultHeading.focus({preventScroll: true}); }
    }

    function begin(quiet) {
      answers = [];
      current = 0;
      root.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      showPane(run);
      renderStep(0, quiet);
    }

    startBtn.addEventListener('click', function () {
      answers = [];
      current = 0;
      showPane(run);
      renderStep(0);
      run.scrollIntoView({behavior: scrollBehavior, block: 'center'});
    });

    steps.forEach(function (step, index) {
      step.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          step.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          answers[index] = btn.getAttribute('data-votes');
          current = index + 1;
          if (current >= steps.length) finish();
          else renderStep(current);
        });
      });

      var back = step.querySelector('[data-quiz-back]');
      if (back) {
        back.addEventListener('click', function () {
          current = Math.max(0, index - 1);
          renderStep(current);
        });
      }
    });

    var restart = root.querySelector('[data-quiz-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        if (openMode) {
          begin(false);
          run.scrollIntoView({behavior: scrollBehavior, block: 'center'});
          return;
        }
        answers = [];
        current = 0;
        root.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        showPane(intro);
        intro.scrollIntoView({behavior: scrollBehavior, block: 'center'});
      });
    }

    if (openMode) begin(true);
  });
})();
